import React from 'react';
import Products from '../components/Products';

const AllProducts = () => {
  return <Products />;
};

export default AllProducts;
